import React, { useState } from "react";
import { connect } from "react-redux";
import RequestGradeCartButton from "./../../components/RequestGradeCartButton/RequestGradeCartButton";

import './CompanyFoundDetails.scss';


const PAGE_SIZE = 4;

const CompanyFoundDetails = ({ companies }) => {

    const [page, setPage] = useState(1);
    const [loadingIdentifier, setLoadingIdentifier] = useState(false);

    const handleClickShowMore = () => {
        setPage(page + 1);
    }

    return (
        <div className="company-found-details text-start ps-3">
            <h3>Resultados</h3>
            <p className="text-dark col-111 small mb-3">Haz clic sobre el botón Consultar Grade para saber si está disponible. Añade a tu bolsa de compra tantas empresas como quieras y después formaliza la
                adquisición a través del botón superior de compra.</p>
            <table>
                <thead>
                    <tr className="table-header">
                        <th>Identificador</th>
                        <th>Razón social</th>
                        <th>Sede social</th>
                        <th>Grade disponible</th>
                    </tr>
                </thead>
                {companies.slice(0, PAGE_SIZE * page).map((company) => {
                    return (
                        <tr className="table-data" key={company.identification}>
                            <td className="info" data-label="Identificador">{company.debtor.identification}</td>
                            <td className="info" data-label="Razón social">{company.debtor.name}</td>
                            <td className="info" data-label="Sede social">{company.debtor.address}</td>
                            <td className="info" data-label="Grade disponible"><RequestGradeCartButton company={company} loadingIdentifier={loadingIdentifier} setLoadingIdentifier={setLoadingIdentifier} /></td>
                        </tr>
                    )
                })}
            </table>
            <div className="showmore">
                <button className={`more-button my-4 ${companies.length <= (page * PAGE_SIZE) ? 'button-show-more-disabled' : null}`} onClick={handleClickShowMore} disabled={companies.length <= (page * PAGE_SIZE)}>Ver más</button>
            </div>
        </div>
    )

}

const mapStateToProps = (state) => {
    return {
        totalItems: state.totalItems,
        items: state.items
    }
}

export default connect(mapStateToProps)(CompanyFoundDetails)
